var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFeaturesSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00002 15.25H3.0001L2.99993 15.2408C2.93988 11.9859 4.15193 8.91588 6.40683 6.61276C8.66174 4.32212 11.6827 3.0625 14.9375 3.0625C21.5864 3.0625 27 8.47614 27 15.125V22.25C27 22.4864 26.7989 22.6875 26.5625 22.6875C26.3262 22.6875 26.125 22.4864 26.125 22.25V15.125C26.125 8.96174 21.114 3.9375 14.9375 3.9375C11.9183 3.9375 9.11394 5.1022 7.03067 7.22477C4.93543 9.3593 3.82391 12.2004 3.87502 15.2293V22.3625C3.87502 22.62 3.67776 22.8125 3.43752 22.8125C3.20116 22.8125 3.00002 22.6114 3.00002 22.375V15.25Z",
    fill: "#067FE5",
    stroke: "#9BCCF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.425 15.5625H7.2625C4.6375 15.5625 2.5 17.7 2.5 20.325V22.675C2.5 25.3 4.6375 27.4375 7.2625 27.4375H7.425C10.05 27.4375 12.1875 25.3 12.1875 22.675V20.325C12.1875 17.7 10.05 15.5625 7.425 15.5625Z",
    fill: "#067FE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7375 15.5625H22.575C19.95 15.5625 17.8125 17.7 17.8125 20.325V22.675C17.8125 25.3 19.95 27.4375 22.575 27.4375H22.7375C25.3625 27.4375 27.5 25.3 27.5 22.675V20.325C27.5 17.7 25.3625 15.5625 22.7375 15.5625Z",
    fill: "#067FE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeaturesSupport);
export default __webpack_public_path__ + "static/media/icon-features-support.1ec6d5dd503f9d63c316b743f4ac7f79.svg";
export { ForwardRef as ReactComponent };